import React from 'react'

import type { PartnerData, PartnerEditorState } from '@oldComponents/PartnerEditor/types'

export function useInvoiceDetailsPartnerEditor() {
  const [editor, setEditor] = React.useState<PartnerEditorState>({
    data: null,
    open: false,
  })

  const open = React.useCallback(
    (newOption: { name: string }, callback: (payload: PartnerData) => unknown) => {
      setEditor({
        open: true,
        data: { name: newOption.name },
        callback,
      })
    },
    [setEditor]
  )

  const close = React.useCallback(() => {
    setEditor(prevState => ({
      ...prevState,
      open: false,
    }))
  }, [setEditor])

  return {
    editor,
    open,
    close,
  }
}
